/**
 * Agrega los interceptores de seguridad al cliente axios.
 *
 * @export
 * @param {IdentityProvider} idp provedor de seguridad (ej: Keycloak)
 */
export function addSecurity(client, idp) {
    client.defaults.withCredentials = true;
    // Agrega el token al request
    client.interceptors.request.use(createSecurityRequestInterceptor(idp));
    // Procesa los errores de seguridad
    client.interceptors.response.use(response => response, createSecurityErrorInterceptor(idp));
}
/**
 * Interceptor de Request. Obtiene y agrega el token al request
 *
 * @param {IdentityProvider} idp provider del token (ej: Keycloak)
 * @returns funcion interceptora de Axios
 */
function createSecurityRequestInterceptor(idp) {
    return async (config) => {
        // Solo modificar el request si esta autenticado
        if (idp.authenticated) {
            try {
                // Obtener el token y agregarlo al request
                const token = await idp.getToken();
                config.headers.Authorization = `Bearer ${token}`;
            }
            catch (e) {
                console.error("Error al refrescar token");
                // Si falla la obtencion del token, simular un error 401 - Unauthorized
                throw {
                    config,
                    response: {
                        status: 401,
                        statusText: "Unauthorized",
                        config
                    }
                };
            }
        }
        return config;
    };
}
/**
 * Interceptor de Response.
 * Maneja el error "401 - Unauthorized" y propaga cualquier otro.
 *
 * @param {IdentityProvider} idp provider del token (ej: Keycloak)
 * @returns funcion interceptora de Axios
 */
function createSecurityErrorInterceptor(idp) {
    return (error) => {
        if (error.response && error.response.status === 401) {
            // Authentication Error
            console.error("Error de Autenticacion, redireccionando a pagina de login...");
            // TODO Revisar esta logica
            const authPromise = idp.authenticated ? idp.logout() : idp.login();
            return authPromise.catch(() => {
                console.error("Error al autenticar al usuario");
                throw error;
            });
        }
        // Si no es error 401, propagarlo
        return Promise.reject(error);
    };
}
//# sourceMappingURL=security.js.map